module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "synErrorDialog"
  }, [_c('md-dialog-title', [_vm._v("Resolução de erro")]), _vm._v(" "), _c('md-dialog-content', [_c('div', [_c('span', [_c('b', [_vm._v("Fonte do problema:")]), _vm._v(" " + _vm._s(_vm.error))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Itens com problema")])]), _vm._v(" "), _c('md-list', _vm._l((_vm.photoErrors), function(item, key) {
    return _c('md-list-item', {
      key: item['.key']
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(item.name) + " - " + _vm._s(item.photo.name))]), _vm._v(" "), _c('camera-image-select', {
      ref: "cameraImageSelect",
      refInFor: true,
      attrs: {
        "photoId": key,
        "description": item.photo.description,
        "imageId": item.photo.image
      }
    })], 1)])
  }), 1), _vm._v(" "), _c('div', [_c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startProcess
    }
  }, [_vm._v("ENVIAR DADOS")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91e57812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SyncErrorDialog.vue
// module id = 840
// module chunks = 1